import { Theme } from '@infotech-soe/erp-ui-kit';
import { createSelector } from '@reduxjs/toolkit';

import { AllowedThemeName } from '../../constants/theme';
import { AppState } from '../reducers/root';

export const getCurrentTheme = (state: AppState): Theme => state.theme.current;

export const getCurrentThemeName = (state: AppState): AllowedThemeName =>
  state.theme.name;

export const isDarkTheme = createSelector(
  getCurrentTheme,
  theme => theme.colorScheme === 'dark'
);
